import { render, staticRenderFns } from "./Sirene.vue?vue&type=template&id=4a4e4bc1&scoped=true"
import script from "./Sirene.vue?vue&type=script&lang=js"
export * from "./Sirene.vue?vue&type=script&lang=js"
import style0 from "./Sirene.vue?vue&type=style&index=0&id=4a4e4bc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e4bc1",
  null
  
)

export default component.exports